import { cn } from '@/utils/cn';
import { TopGames } from '../games/TopGames/TopGames';
import { BestProviders } from '../providers/BestProviders';

interface SeoPagesTopSidebarProps {
  className?: string;
}

export const SeoPagesTopSidebar = ({ className }: SeoPagesTopSidebarProps) => {
  return (
    <div className={cn(className)}>
      <TopGames />
      <BestProviders />
    </div>
  );
};
